import React from "react";
import { money, num } from "@/lib/format";

// Read-only step rows under an assembly line: one row per thing a crew does, per unit and extended to the line quantity.
export function LineStepRows({ lineId, steps, unit }) {
  if (!steps?.rows?.length) return null;
  const s = steps.sum;
  return (
    <div className="bg-slate-50/70 border-t border-slate-100 pl-10 pr-4 py-1.5 overflow-x-auto" data-testid={`line-steps-${lineId}`}>
      <div className="min-w-[640px]">
      <div className="grid gap-2 text-[11px] uppercase tracking-wide text-slate-400 pb-1" style={{ gridTemplateColumns: STEP_COLS }}>
        <span>Step</span><span className="text-right">MH / {unit || "unit"}</span><span className="text-right">Material / {unit || "unit"}</span>
        <span className="text-right">MH</span><span className="text-right">Labor</span><span className="text-right">Material</span>
      </div>
      {steps.rows.map((r, i) => (
        <div key={i} className={`grid gap-2 text-[11px] py-0.5 ${r.is_group ? "font-semibold text-slate-700" : "text-slate-600"}`} style={{ gridTemplateColumns: STEP_COLS }} data-testid={`line-step-${lineId}-${i}`}>
          <span className="truncate" style={{ paddingLeft: r.depth * 14 }} title={r.name}>{r.is_group ? "▸ " : "· "}{r.name}</span>
          <span className="text-right font-mono">{r.mh_per_unit.toFixed(4)}</span>
          <span className="text-right font-mono">{money(r.mat_per_unit, 2)}</span>
          <span className="text-right font-mono">{r.is_group ? "" : num(r.mh)}</span>
          <span className="text-right font-mono">{r.is_group ? "" : money(r.labor)}</span>
          <span className="text-right font-mono">{r.is_group ? "" : money(r.material)}</span>
        </div>
      ))}
      <div className="grid gap-2 text-[11px] py-1 mt-0.5 border-t border-slate-200 font-semibold text-[#003E87]" style={{ gridTemplateColumns: STEP_COLS }} data-testid={`line-steps-sum-${lineId}`}>
        <span>Steps total ({s.steps})</span>
        <span className="text-right font-mono">{s.mh_per_unit.toFixed(4)}</span>
        <span className="text-right font-mono">{money(s.mat_per_unit, 2)}</span>
        <span className="text-right font-mono">{num(s.mh)}</span>
        <span className="text-right font-mono">{money(s.labor)}</span>
        <span className="text-right font-mono">{money(s.material)}</span>
      </div>
      </div>
    </div>
  );
}

const STEP_COLS = "minmax(160px,1fr) 90px 110px 80px 100px 100px";
